<template>
  <v-flex v-if="openAddBg === false" class="pl-2 mb-4 pr-2">
    <v-layout align-start justify-start row class="mb-4">
      <v-icon color="primary" style="font-size: 50px;">group</v-icon>
      <h2
        :style="`color: ${$vuetify.theme.primary}`"
        class="mt-2 ml-2"
      >{{$translate('BATCHGROUPS')}}</h2>
      <v-spacer></v-spacer>
      <v-btn
        fab
        :disabled="disableAdd || eventForm.type === 'Theme'"
        right
        color="secondary"
        @click="addBatchgroup"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-dialog v-model="deleteBGDialog" max-width="290" hide-overlay>
        <v-card>
          <v-card-title class="headline">{{$translate('BATCHGROUP_DELETE')}}</v-card-title>
          <v-card-text>
            {{$translate('BATCHGROUP_CONF_DELETE')}}
            <i>{{batchGroupToBeDelete.Name}}</i> ?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              round
              color="secondary"
              @click.native="deleteBGDialog = false"
            >{{$translate('CANCEL')}}</v-btn>
            <v-btn round color="primary" @click.native="deleteBatchgroup()">{{$translate('YES')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-spacer></v-spacer>
    <v-data-table
      :headers="headers"
      :items="filteredBatchGroupList"
      class="elevation-1"
      :rows-per-page-items="[10]"
    >
      <template v-slot:items="props">
        <td>{{ props.item.Name }}</td>
        <td class="text-xs-right">{{ props.item.Type }}</td>
        <td class="text-xs-right" v-if="props.item.Type === 'Specific'">{{ props.item.JoinedDates.toString("") }}</td>
        <td
          class="text-xs-right"
          v-if="props.item.Type === 'Repeating'"
        >{{ props.item.StartDate + " - " + props.item.EndDate }}</td>
        <td class="justify-start">
          <v-btn small class="v-btn-tiny mr-2" color="primary" @click="viewBGDetails(props.item)">
            <v-icon small>border_color</v-icon>
          </v-btn>
            <v-btn
              :disabled="disableAdd"
              small
              class="v-btn-tiny"
              color="primary"
              @click="showDeleteBGDialog(props.item)"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <v-dialog v-model="errorDeleteBatchGroup" max-width="290">
              <v-card>
                <v-card-title class="headline">{{$translate('E_PC_003')}}</v-card-title>
                <v-card-actions>
                  <v-btn @click="errorDeleteBatchGroup = false">
                    {{$translate('CLOSE')}}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
        </td>
      </template>
    </v-data-table>
  </v-flex>
  <v-flex v-else>
    <v-dialog v-model="errorDialog" max-width="290" persistent>
      <v-card>
        <v-card-title class="headline">{{$translate('ERROR')}}</v-card-title>
        <v-card-text>{{$translate('FORM_VALIDATE_1_TITLE')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn round color="primary" @click="errorDialog = false">{{$translate('NEXT')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorDialogDate" max-width="290" persistent>
      <v-card>
        <v-card-title class="headline">{{$translate('ERROR')}}</v-card-title>
        <v-card-text>{{$translate('BATCHGROUP_NOPASTDATE')}}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn round color="primary" @click="errorDialogDate = false">{{$translate('NEXT')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openAddBg" persistent content-class="dialog_class" max-width="1300">
      <v-container>
        <v-flex xs12 class="mx-auto containerBackground">
          <v-container style="width:auto" grid-list-xl>
            <v-layout row wrap>
              <v-flex xs12 md4>
                <v-card class="elevation-0 mb-4 mt-2 transparent">
                  <v-layout justify-center>
                    <v-card
                      round
                      class="lindaTextMediumBatchgroup elevation-1"
                    >
                      <v-card-text>
                        <p
                          class="fontSize"
                          :style="getFontProperty()"
                        >{{$translate('LINDA_BG_MEANING')}}</p>
                        <p
                          class="fontSize"
                          :style="getFontProperty()"
                        >{{$translate('LINDA_BG_FILLING')}}</p>
                      </v-card-text>
                    </v-card>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 md8>
                <v-form ref="batchgroupForm" v-model="valid" lazy-validation>
                <v-card class="transparent elevation-0 dialogAddBG">
                  <v-layout align-start justify-start row class="mb-4">
                    <v-icon color="primary" style="font-size: 50px;">group</v-icon>
                    <h2
                      v-if="editMode === true"
                      :style="`color: ${$vuetify.theme.primary}`"
                      class="mt-2"
                    >{{$translate('VIEW_BATCHGROUP')}}</h2>
                    <h2
                      v-else
                      :style="`color: ${$vuetify.theme.primary}`"
                      class="mt-2"
                    >{{$translate('CREATE_BATCHGROUP')}}</h2>
                    <!-- <v-spacer></v-spacer> -->
                  </v-layout>
                  <v-flex xs12>
                    <h3>{{$translate('NAME')}}</h3>
                    <v-card class="blockForInputfields">
                      <v-layout row justify-space-between>
                        <v-flex xs5>
                          <v-text-field
                            outline
                            :label="$translate('BATCHGROUP_NAME')"
                            v-model="batchgroupForm.Name"
                            item-text="label"
                            item-value="value"
                            :rules="textRule"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex
                          v-if="eventForm.type === 'OrderEvent' ||
                                eventForm.type === 'Delivery' ||
                                eventForm.type === 'PickUp'"
                          xs5
                        >
                          <v-select
                            outline
                            :rules="textRule"
                            :label="$translate('ORDER_TYPE')"
                            v-model="batchgroupForm.Orderable"
                            :items="orderTypesArray"
                            item-text="name"
                            item-value="id"
                            persistent-hint
                            :disabled="editMode === true || eventForm.type === 'Delivery' || eventForm.type === 'PickUp'"
                          ></v-select>
                        </v-flex>
                        <v-flex xs5>
                          <v-select
                            clearable
                            v-model="batchgroupForm.LocationId"
                            :items="batchgroupLocations"
                            outline
                            item-value="LocationId"
                            item-text="LocationName"
                            label="Batchgroup Location"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
<!--                    Start-->
                  <v-flex xs12>
                    <v-layout row align-center>
                      <h3>{{$translate('START')}}</h3>
                      <h5 class="requiredField"> - {{$translate('REQUIRED')}}</h5>
                    </v-layout>
                    <v-card class="blockForInputfields">
                      <v-layout row wrap justify-space-between>
                        <v-flex xs5>
                          <v-text-field
                            type="time"
                            outline
                            slot="activator"
                            v-model="batchgroupForm.MinArrivalTime"
                            :label="$translate('EVENT_EARLIEST_CHECKIN_TIME')"
                            append-icon="access_time"
                            :rules="timeRule"
                            mask="time"
                            hint="Example: 08:30"
                            :disabled="editMode === true"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5>
                          <v-text-field
                            v-model="batchgroupForm.MaxArrivalTime"
                            outline
                            type="time"
                            :disabled="editMode === true"
                            :label="$translate('EVENT_LATEST_CHECKIN_TIME')"
                            append-icon="access_time"
                            mask="time"
                            hint="Example: 17:30"
                            :rules="timeRule"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5>
                          <v-text-field
                            v-model="batchgroupForm.ArrivalBatchDuration"
                            :disabled="editMode === true"
                            type="number"
                            min="1"
                            step="1"
                            suffix="min"
                            :rules="textRule"
                            required
                            :label="$translate('EVENT_DURATION_ARRIVAL_BATCHES')"
                            outline
                            item-text="label"
                            item-value="value"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5 v-if="eventForm.type !== 'Fixed'">
                          <v-text-field
                            :disabled="editMode === true"
                            type="number"
                            min="1"
                            step="1"
                            suffix="min"
                            :rules="textRule"
                            required
                            :label="$translate('BATCHGROUP_INTERVAL')"
                            v-model="batchgroupForm.StartBatchFrequency"
                            outline
                            item-text="label"
                            item-value="value"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5>
                          <v-text-field
                            type="number"
                            min="1"
                            :label="$translate('EVENT_MAX_INFLOW')"
                            v-model="batchgroupForm.MaxInflow"
                            item-text="label"
                            item-value
                            :rules="textRule"
                            required
                            outline
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
<!--                 end -->
                  <v-flex
                    xs12
                    v-if="eventForm.type !== 'OrderEvent' &&
                          eventForm.type !== 'Repetitive' &&
                          eventForm.type !== 'Tour' &&
                          eventForm.type !== 'Delivery' &&
                          eventForm.type !== 'PickUp'"
                  >
                    <h3>{{$translate('END')}}</h3>
                    <v-card class="blockForInputfields">
                      <v-layout row wrap justify-space-between>
                        <v-flex xs5>
                          <v-text-field
                            v-model="batchgroupForm.MinDepartureTime"
                            type="time"
                            outline
                            slot="activator"
                            :label="$translate('EVENT_EARLIEST_CHECKOUT_TIME')"
                            append-icon="access_time"
                            :rules="timeRule"
                            mask="time"
                            hint="Example: 08:30"
                            :disabled="editMode == true"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5>
                          <v-text-field
                            v-model="batchgroupForm.MaxDepartureTime"
                            outline
                            type="time"
                            :disabled="editMode == true"
                            :label="$translate('EVENT_LATEST_CHECKOUT_TIME')"
                            append-icon="access_time"
                            mask="time"
                            hint="Example: 17:30"
                            :rules="timeRule"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5>
                          <v-text-field
                            v-model="batchgroupForm.DepartureBatchDuration"
                            :disabled="editMode == true"
                            type="number"
                            min="1"
                            step="1"
                            suffix="min"
                            :rules="textRule"
                            required
                            :label="$translate('EVENT_DURATION_DEPARTURE_BATCHES')"
                            outline
                            item-text="label"
                            item-value="value"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5 v-if="eventForm.type !== 'Fixed'">
                          <v-text-field
                            :disabled="editMode == true"
                            type="number"
                            min="1"
                            step="1"
                            suffix="min"
                            :rules="textRule"
                            required
                            :label="$translate('BATCHGROUP_INTERVAL_END')"
                            v-model="batchgroupForm.EndBatchFrequency"
                            outline
                            item-text="label"
                            item-value="value"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5>
                          <v-text-field
                            type="number"
                            min="1"
                            :label="$translate('EVENT_MAX_OUTFLOW')"
                            v-model="batchgroupForm.MaxOutflow"
                            item-text="label"
                            item-value
                            :rules="textRule"
                            required
                            outline
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
<!--                  period info-->
                  <v-flex xs12 v-if="eventForm.type === 'FlexEvent' || eventForm.type === 'Rental'">
                    <h3>{{$translate('PERIOD_INFO')}}</h3>
                    <v-card class="blockForInputfields">
                      <v-layout row wrap justify-space-between>
                          <v-flex xs5>
                            <v-select
                              :disabled="editMode === true"
                              v-model="batchgroupForm.Unit"
                              :items="unitTypes"
                              :rules="textRule"
                              required
                              outline
                            ></v-select>
                          </v-flex>
                          <v-flex xs5>
                            <v-text-field
                              v-model="batchgroupForm.Steps"
                              :disabled="editMode === true"
                              type="number"
                              min="1"
                              step="1"
                              :suffix="batchgroupForm.Unit"
                              :rules="textRule"
                              required
                              :label="$translate('EVENT_STEPS')"
                              outline
                              item-text="label"
                              item-value="value"
                            ></v-text-field>
                          </v-flex>
                        <v-flex xs5>
                          <v-text-field
                            v-model="batchgroupForm.MinBookingDuration"
                            :disabled="editMode === true"
                            type="number"
                            min="1"
                            step="1"
                            :suffix="batchgroupForm.Unit"
                            :rules="textRule"
                            required
                            :label="$translate('EVENT_MINIMAL_DURATION')"
                            outline
                            item-text="label"
                            item-value="value"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5>
                          <v-text-field
                            v-model="batchgroupForm.MaxBookingDuration"
                            :disabled="editMode === true"
                            type="number"
                            min="1"
                            step="1"
                            :suffix="batchgroupForm.Unit"
                            :rules="textRule"
                            required
                            :label="$translate('EVENT_MAXIMUM_DURATION')"
                            outline
                            item-text="label"
                            item-value="value"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
<!--                  date/time info-->
                  <v-flex xs12>
                    <h3>{{$translate('DATE/TIMEINFO')}}</h3>
                    <v-card class="blockForInputfields">
                      <v-layout column justify-space-between>
                        <v-flex xs12>
                          <h3
                            v-if="!editMode"
                            :style="`color: ${$vuetify.theme.primary}`"
                          >{{$translate('BATCHGROUP_CHOOSETYPE')}}</h3>
                        </v-flex>
                        <v-radio-group
                          :rules="textRule"
                          required
                          :disabled="editMode"
                          v-model="radioSelect"
                          @change="setRadio"
                          row
                          :mandatory="false"
                        >
                          <v-radio
                            :disabled="editMode == true"
                            :label="$translate('BATCHGROUP_TYPERE')"
                            color="primary"
                            value="repeat"
                          ></v-radio>
                          <v-radio
                            :disabled="editMode == true"
                            :label="$translate('BATCHGROUP_TYPESP')"
                            color="primary"
                            value="specific"
                          ></v-radio>
                        </v-radio-group>
                        <div v-if="radioSelect === 'repeat'" class="mb-4">
                          <h3
                            v-if="!editMode"
                            :style="`color: ${$vuetify.theme.primary}`"
                          >{{$translate('BATCHGROUP_DAYS')}}</h3>
                          <v-layout class="mb-2 ml-2">
                            <v-checkbox
                              :disabled="batchConfig.hasOwnProperty('JoinedDays') &&
                                         batchConfig.JoinedDays.includes('Mon')"
                              :label="$translate('DAY_MON')"
                              value="Mon"
                              color="primary"
                              hide-details
                              v-model="daySelected"
                            />
                            <v-checkbox
                              class="checkbox_lining"
                              :disabled="batchConfig.hasOwnProperty('JoinedDays') &&
                                         batchConfig.JoinedDays.includes('Tue')"
                              :label="$translate('DAY_TUE')"
                              value="Tue"
                              color="primary"
                              hide-details
                              v-model="daySelected"
                            />
                            <v-checkbox
                              class="checkbox_lining"
                              :disabled="batchConfig.hasOwnProperty('JoinedDays') &&
                                         batchConfig.JoinedDays.includes('Wed')"
                              :label="$translate('DAY_WED')"
                              value="Wed"
                              color="primary"
                              hide-details
                              v-model="daySelected"
                            />
                            <v-checkbox
                              class="checkbox_lining"
                              :disabled="batchConfig.hasOwnProperty('JoinedDays') &&
                                         batchConfig.JoinedDays.includes('Thu')"
                              :label="$translate('DAY_THU')"
                              value="Thu"
                              color="primary"
                              hide-details
                              v-model="daySelected"
                            />
                            <v-checkbox
                              class="checkbox_lining"
                              :disabled="batchConfig.hasOwnProperty('JoinedDays') &&
                                         batchConfig.JoinedDays.includes('Fri')"
                              :label="$translate('DAY_FRI')"
                              value="Fri"
                              color="primary"
                              hide-details
                              v-model="daySelected"
                            />
                            <v-checkbox
                              class="checkbox_lining"
                              :disabled="batchConfig.hasOwnProperty('JoinedDays') &&
                                         batchConfig.JoinedDays.includes('Sat')"
                              :label="$translate('DAY_SAT')"
                              value="Sat"
                              color="primary"
                              hide-details
                              v-model="daySelected"
                            />
                            <v-checkbox
                              class="checkbox_lining"
                              :disabled="batchConfig.hasOwnProperty('JoinedDays') &&
                                         batchConfig.JoinedDays.includes('Sun')"
                              :label="$translate('DAY_SUN')"
                              value="Sun"
                              color="primary"
                              hide-details
                              v-model="daySelected"
                            />
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs5 class="small_input ml-2">
                              <v-menu
                                ref="menu3"
                                :close-on-content-click="true"
                                v-model="menu3"
                                :nudge-right="40"
                                :return-value.sync="tmpStartDate"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="computedDateFormattedStartDate"
                                  :rules="textRule"
                                  required
                                  outline
                                  prepend-icon="event"
                                  readonly
                                ></v-text-field>
                                <v-date-picker
                                  :min="today"
                                  :max="editMode ? batchConfig.StartDate.split('-').reverse().join('-') : ''"
                                  first-day-of-week="1"
                                  v-model="tmpStartDate"
                                  @input="selectStartDate"
                                  no-title
                                />
                              </v-menu>
                            </v-flex>
                            <v-flex xs5 class="small_input ml-2">
                              <v-menu
                                ref="menu4"
                                :close-on-content-click="true"
                                v-model="menu4"
                                :nudge-right="40"
                                :return-value.sync="tmpEndDate2"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="computedDateFormattedEndDate"
                                  outline
                                  hide-details
                                  prepend-icon="event"
                                  readonly
                                  :rules="textRule"
                                  required
                                ></v-text-field>
                                <v-date-picker
                                  :min="editMode ? batchConfig.EndDate.split('-').reverse().join('-') : ''"
                                  first-day-of-week="1"
                                  v-model="tmpEndDate"
                                  @input="selectEndDate"
                                  no-title
                                />
                              </v-menu>
                            </v-flex>
                          </v-layout>
                        </div>
                        <div v-else-if="radioSelect === 'specific'" class="mb-4">
                          <v-flex xs8 class="small_input">
                            <v-menu
                              ref="menu"
                              v-model="menu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="selectDates"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              readonly
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-combobox
                                  readonly
                                  :rules="comboRule"
                                  required
                                  outline
                                  hide-details
                                  color="primary"
                                  multiple
                                  chips
                                  small-chips
                                  v-model="computedFormattedSelectDates"
                                  :label="$translate('DATE')"
                                  append-icon="event"
                                  v-on="on"
                                ></v-combobox>
                              </template>
                              <v-date-picker
                                first-day-of-week="1"
                                v-model="selectDates"
                                :min="today"
                                multiple
                                :allowed-dates="allowedDatesFromSelectDates"
                                no-title
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  flat
                                  color="primary"
                                  @click="menu = false"
                                >{{$translate('CANCEL')}}</v-btn>
                                <v-btn
                                  flat
                                  color="primary"
                                  @click="$refs.menu.save(selectDates)"
                                >{{$translate('SAVE')}}</v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-layout row wrap>
                            <v-flex
                              v-if="editMode && batchgroupForm.JoinedDays"
                              xs5
                              class="small_input"
                            >
                              <v-text-field
                                :rules="textRule"
                                required
                                outline
                                type="text"
                                v-model="batchgroupForm.JoinedDays"
                                :label="$translate('BATCHGROUP_DATES')"
                                :disabled="editMode === true"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-layout>
                      <v-layout row justify-space-between>
                        <v-flex xs5>
                          <v-select
                            outline
                            :label="$translate('EVENT_BOOKING_POLICY')"
                            v-model="batchgroupForm.BookingPolicy"
                            :items="policies"
                            item-text="Name"
                            return-object
                            persistent-hint
                            required
                          ></v-select>
                        </v-flex>
                        <v-flex xs5>
                          <v-text-field
                            type="number"
                            min="0"
                            step="1"
                            suffix="%"
                            :rules="flexNumberRule"
                            required
                            :label="$translate('EVENT_FLEX_PERCENTAGE')"
                            v-model="batchgroupForm.FlexPercentage"
                            item-text="label"
                            item-value="value"
                            outline
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
<!--                  Price info-->
                  <v-flex xs12>
                    <h3>{{$translate('PRICECATEGORIES')}}</h3>
                    <v-card class="blockForInputfields">
                      <v-layout row justify-space-between>
                        <v-flex xs5 v-if="eventForm.type === 'Rental' || eventForm.type === 'FlexEvent'">
                          <v-text-field
                            type="number"
                            min="0"
                            suffix="%"
                            outline
                            :rules="textRule"
                            required
                            label="% of original price"
                            v-model="batchgroupForm.PricePercentage"
                            item-text="label"
                            item-value="value"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-flex xs12>
                        <h4 text-xs-left>{{$translate('EVENT_PRICE_CATEGORY')}}</h4>
                        <v-card class="elevation-0 priceCategoriesCard">
                          <v-toolbar flat color="white">
                            <v-spacer></v-spacer>
                            <v-dialog v-model="priceCategoriesDialog" max-width="670px" persistent>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  class="text-capitalize"
                                  color="secondary"
                                  round
                                  @click="addNewPriceCategorie"
                                  v-on="on"
                                >{{$translate('EVENT_ADD_PRICE_CATEGORY')}}</v-btn>
                              </template>
                              <v-card>
                                <v-card-title>
                                  <span class="headline">{{ formTicketTitle }}</span>
                                </v-card-title>

                                <v-card-text>
                                  <v-container grid-list-md>
                                    <v-layout wrap>
                                      <v-flex xs12 sm6 md7>
                                        <v-select
                                          v-if="newPriceCategorie"
                                          :disabled="!newPriceCategorie"
                                          v-model="editedPriceCategoriesItem.Name"
                                          :items="potentialPriceCategories"
                                          item-text="Name"
                                          :label="$translate('NAME')"
                                          outline
                                        ></v-select>
                                        <v-text-field
                                          v-else
                                          disabled
                                          v-model="editedPriceCategoriesItem.Name"
                                          :label="$translate('NAME')"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex xs12 sm6 md5>
                                        <v-text-field
                                          required
                                          input="number"
                                          min="0"
                                          max="100"
                                          v-model="editedPriceCategoriesItem.Price"
                                          type="number"
                                          :label="$translate('PRICE2')"
                                          prefix="€"
                                        ></v-text-field>
                                        <v-text-field
                                          v-if="eventConfig.type === 'OrderEvent' && batchgroupForm.Orderable === 2"
                                          input="number"
                                          min="0"
                                          max="100"
                                          v-model="editedPriceCategoriesItem.FreeThreshold"
                                          type="number"
                                          :label="$translate('EVENT_THRESHOLD')"
                                          prefix="€"
                                        ></v-text-field>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-card-text>

                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    color="secondary"
                                    round
                                    @click="closePriceCategoriesdialog"
                                  >{{$translate('CANCEL')}}</v-btn>
                                  <v-btn
                                    color="primary"
                                    :disabled="potentialPriceCategories.length === 0"
                                    round
                                    @click="savePriceCategories"
                                  >{{$translate('SAVE')}}</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-toolbar>
                          <v-data-table
                            :headers="priceCategoriesHeaders"
                            :items="batchgroupPriceCategories"
                            class="elevation-1"
                          >
                            <template v-slot:items="props">
                              <td>{{ props.item.Name }}</td>
                              <td>{{ props.item.Price }}</td>
                              <td class="justify-center layout px-0">
                                <v-icon
                                  small
                                  class="mr-2"
                                  @click="editPriceCategories(props.item)"
                                >edit</v-icon>
                                <v-icon
                                  small
                                  @click="deletePriceCategories(props.item)"
                                >delete</v-icon>
                              </td>
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-flex>
                      <v-flex xs5>
                        <v-text-field
                          type="number"
                          min="0"
                          :rules="numberRule"
                          outline
                          :label="$translate('EVENT_REWARD_POINTS')"
                          v-model="batchgroupForm.RewardPoints"
                        ></v-text-field>
                      </v-flex>
                    </v-card>
                  </v-flex>
                  <v-layout row justify-end class="mt-1">
                    <v-btn
                      round
                      color="secondary"
                      @click="signalCloseBatchGroupDialog({})"
                    >{{$translate('CANCEL')}}</v-btn>
                    <v-btn
                      round
                      color="primary"
                      @click="savingBatchgroup"
                    >{{$translate('SAVE')}}</v-btn>
                  </v-layout>
                </v-card>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-container>
    </v-dialog>
    <v-dialog v-model="wrongDateDialog" max-width="290" persistent>
      <v-card>
        <v-card-title class="headline">{{$translate('ERROR')}}</v-card-title>
        <v-card-text>{{$translate('START_END_DATE_EQUAL_ERROR')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn round color="primary" @click="wrongDateDialog = false">{{$translate('NEXT')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorPriceCategoriesDialog" max-width="290" persistent>
      <v-card>
        <v-card-title class="headline">{{$translate('ERROR')}}</v-card-title>
        <v-card-text>{{$translate('EVENT_PLEASE_ADD_PRICECATEGORY')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            round
            color="primary"
            @click="errorPriceCategoriesDialog = false"
          >{{$translate('NEXT')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import * as dssRequest from '@/api/dssRequest';
import BaseObject from '@/objects/BaseObject';
import EventObject2 from '@/objects/EventObject2.js';
import CreateEventObject2 from '@/objects/CreateEventObject2';
import _ from 'lodash';
import { weekdays } from '@/shared/utility';
import { mapGetters } from 'vuex';
import { objectToArray } from '@/shared/utility.js';
import BatchGroupObject from '@/objects/BatchGroupObject.js';
import BaseComponent from '@/components/base/BaseComponent.vue';
import appConfig from '../../../config/app_config';
import { ui_helpers } from '../../shared/ui_helpers';

export default {
  extends: BaseComponent,
  mixins: [ui_helpers],
  name: 'Events_Batchgroups',
  components: {},
  computed: {
    computedDateFormattedStartDate() {
      return this.formatDate(this.tmpStartDate);
    },
    computedDateFormattedEndDate() {
      return this.formatDate(this.tmpEndDate);
    },
    computedFormattedSelectDates() {
      const returnDates = [];
      this.selectDates.forEach((e) => {
        returnDates.push(e.split('-').reverse().join('-'));
      });
      return returnDates;
    },
    formTitle() {
      return this.editedIndex === -1 ? 'New Batchgroup' : 'Edit Batchgroup';
    },
    formTicketTitle() {
      return this.editedPriceCategoriesIndex === -1
        ? 'New price categorie'
        : 'Edit price categorie';
    },
  },
  watch: {
    batchgroupForm(newVal, oldVal) {
      console.log("batchgroupForm changed: ", newVal, oldVal);
    },
    priceCategoriesDialog(val) {
      val || this.closePriceCategoriesdialog();
    },
    editMode(newVal, oldVal) {
      this.editMode = newVal;
      if (this.$refs.batchgroupForm !== undefined) {
        this.$refs.batchgroupForm.resetValidation();
      }
    },
    eventConfig: {
      handler(newVal) {
        console.log("Brian newVal", newVal);
        this.receivedEventId = newVal.eventId;
        this.getLocations();
        console.log("Brian this.receivedEventId", this.receivedEventId);

        if (this.$refs.batchgroupForm !== undefined) {
          this.$refs.batchgroupForm.resetValidation();
        }
      },
      deep: true,
    },

    batchConfig: {
      handler(newVal, oldVal) {
        this.batchgroupForm = BatchGroupObject._objectDefinition(newVal);

        // Assign default value to Orderable
        if(this.eventConfig.type === 'Delivery') {
          this.batchgroupForm.Orderable = 2;
        } else if(this.eventConfig.type === 'PickUp') {
          this.batchgroupForm.Orderable = 1;
        }

        if (this.$refs.batchgroupForm !== undefined) {
          this.$refs.batchgroupForm.resetValidation();
        }
      },
      deep: true,
    },
    picker(newVal, oldVal) {
      if (newVal == null) {
        this.filteredBatchGroupList = this.batchGroupList;
      } else {
        this.filteredBatchGroupList = [];
        const revertDate = this.picker
          .split('-')
          .reverse()
          .join('-');

        for (const [k, item] of Object.entries(this.batchGroupList)) {
          if (item.Type == 'Specific') {
            if (Object.values(item.Dates).findIndex((e) => e == revertDate) != -1) this.filteredBatchGroupList.push(item);
            continue;
          } else if (item.Type == 'Repeating') {
            const begin = new Date(
              `${item.StartDate.split('-')
                .reverse()
                .join('-')}T00:00:00Z`,
            );
            const end = new Date(
              `${item.EndDate.split('-')
                .reverse()
                .join('-')}T00:00:00Z`,
            );
            const point = new Date(`${newVal}T00:00:00Z`);
            if (
              point.getTime() < begin.getTime()
                || point.getTime() > end.getTime()
            ) continue;

            for (const [k1, v1] of Object.entries(item.Days)) {
              if (v1 == weekdays[point.getDay()]) {
                this.filteredBatchGroupList.push(item);
              }
            }
          } else {
            // this.filteredBatchGroupList.push(item);
          }
        }
      }

      // this.filteredBatchGroupList
    },
  },
  data() {
    return {
      batchgroupLocations: [],
      // errorDialogs
      errorDeleteBatchGroup: false,
      types: [
        'FlexEvent',
        'Fixed',
        'Repetitive',
        'Theme',
        'Tour',
        'Relay',
        'Rental',
        'Complimentary Service',
      ],
      priceCategoriesHeaders: [
        {
          text: this.$translate('NAME'),
          align: 'left',
          sortable: false,
          value: 'Name',
        },
        { text: this.$translate('PRICE2'), value: 'Price', sortable: false },
        {
          text: this.$translate('EVENT_ACTIONS'),
          value: 'Name',
          sortable: false,
          align: 'center',
        },
      ],
      receivedEventId: '',
      policies: [],
      orderTypesArray: [{ name: 'Takeaway', id: 1 }, { name: 'Delivery', id: 2 }],
      unitTypes: ['Minutes', 'Hours', 'Days', 'Weeks'],
      potentialPriceCategories: [],
      batchgroupPriceCategories: [],
      editedPriceCategoriesItem: {
        FreeThreshold: '',
      },
      editedPriceCategoriesIndex: -1,
      priceCategoriesDialog: false,
      newPriceCategorie: false,
      errorPriceCategoriesDialog: false,
      wrongDateDialog: false,
      startTimePicker: false,
      endTimePicker: false,
      eventForm: {},
      batchConfig: {},
      eventConfig: {},
      daySelected: [],
      disableAdd: true,
      tmpStartDate: null,
      tmpEndDate: null,
      current_date: null,
      tmpEndDate2: null,
      batchGroupToBeDelete: {},
      deleteBGDialog: false,
      textRule: [
        (v) => !!v || 'Field is required',
        // v => v != 0 || "Field must at least be 1 char long!"
      ],
      timeRule: [(v) => !!v || 'Time field required (hh:mm)'],
      comboRule: [(v) => !!v || 'Date(s) are required'],
      numberRule: [(v) => v >= 0 || 'Reward points should be positive'],
      flexNumberRule: [(v) => (!isNaN(parseFloat(v)) && v >= 0) || 'Number has to be at least 0 and a valid number'],
      menu: false,
      menu3: false,
      menu4: false,
      tmpEndDate2: null,
      selectDates: [],
      batchgroupForm: BatchGroupObject._objectDefinition(),
      batchGroupList: [],
      filteredBatchGroupList: [],
      valid: true,
      today: '',
      openAddBg: false,
      userGroupIdToBeDeleted: -1,
      dialogDelete: false,
      deleteDisable: false,
      editedItem: {},
      editedIndex: -1,
      radioSelect: null,
      dialog: false,
      errorDialog: false,
      errorDialogDate: false,
      editMode: false,
      roles: [],
      disableButton: true,
      colors: '',

      defaultItem: {
        description: '',
      },
      headers: [
        {
          text: 'Batchgroup name',
          align: 'left',
          sortable: true,
          value: 'Name',
        },
        {
          text: 'Batchgroup type',
          align: 'center',
          sortable: true,
          value: 'Type',
        },
        {
          text: 'Batchgroup date(s)',
          align: 'right',
          sortable: false,
        },
        { text: 'Actions', align: 'center', sortable: false },
      ],
    };
  },
  mounted() {
    this.getTodayDate();
    this.batchgroupPriceCategories = [];
  },
  created() {
    if (!Date.prototype.toISODate) {
      Date.prototype.toISODate = function () {
        return (
          `${this.getFullYear()
          }-${
            (`0${this.getMonth() + 1}`).slice(-2)
          }-${
            (`0${this.getDate()}`).slice(-2)}`
        );
      };
    }
    this.current_date = new Date().toISODate();

    window.EventBus.listen('dataForComponent', this.manageDataForComponent);
  },
  beforeDestroy() {
    window.EventBus.removeListener(
      'dataForComponent',
      this.manageDataForComponent,
    );
  },
  methods: {
    getLocations() {
      console.log("Brian this.eventConfig", this.eventConfig);

      const payload = {
        LanguageTagId: this.$store.getters.getUserLanguage,
        Densities: [0, 1, 2, 3, 4],
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The call `getLocations` on - Events_Batchgroups.vue - was successful',
            response,
          );
          console.log("Lorenzo response.data", response.data);
          if (response.data.hasOwnProperty('Locations')) {
            this.batchgroupLocations = [];
            this.batchgroupLocations = response.data.Locations;
          }
          console.log("Lorenzo this.batchgroupLocations", this.batchgroupLocations);
        },
        (error) => {
          console.log(
            'The call `getLocations` on - Events_Batchgroups.vue - was not successful',
            error,
          );
        },
        'getLocations',
        this.receivedEventId,
        payload,
      );
    },
    getPolicies() {
      const payload = {
        EventId: this.eventConfig.eventId,
      };
      dssRequest.doRequest(
        (response) => {
          console.log('The gerenic call getPolicies was successful', response);
          this.policies = Object.values(response.data);
        },
        (error) => {
          console.log(
            'The generic call getPolicies was not successful',
            error,
          );
        },
        'getPolicies',
        appConfig.dss.eventAdminMng,
        payload,
      );
    },
    editPriceCategories(item) {
      this.editedPriceCategoriesIndex = this.batchgroupPriceCategories.indexOf(
        item,
      );
      this.editedPriceCategoriesItem = { ...item };
      this.priceCategoriesDialog = true;
    },
    deletePriceCategories(item) {
      const index = this.batchgroupPriceCategories.indexOf(item);
      confirm('Are you sure you want to delete this item?')
        && this.batchgroupPriceCategories.splice(index, 1);
    },
    closePriceCategoriesdialog() {
      this.priceCategoriesDialog = false;
      this.newPriceCategorie = false;
      setTimeout(() => {
        this.editedPriceCategoriesItem = {

          ...this.defaulPriceCategoriestItem,
        };
        this.editedPriceCategoriesIndex = -1;
      }, 300);
    },
    addNewPriceCategorie() {
      this.getPriceCategories();
      this.newPriceCategorie = true;
    },
    savePriceCategories() {

      if (!this.editedPriceCategoriesItem.hasOwnProperty('Price') || this.editedPriceCategoriesItem.Price === NaN) {
        this.editedPriceCategoriesItem.Price = 0;
      }
      if (this.editedPriceCategoriesIndex > -1) {
        Object.assign(
          this.batchgroupPriceCategories[this.editedPriceCategoriesIndex],
          this.editedPriceCategoriesItem,
        );
      } else {
        this.potentialPriceCategories.forEach((e) => {
          if (this.editedPriceCategoriesItem.Name === e.Name) {
            this.editedPriceCategoriesItem.PriceCategoryId = e.Id;
          }
        });
        this.batchgroupPriceCategories.push(this.editedPriceCategoriesItem);
      }
      this.closePriceCategoriesdialog();
    },
    getPriceCategories() {
      const payload = {
        EventId: this.eventConfig.eventId,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call getPriceCategories was successful',
            response,
          );
          this.potentialPriceCategories = [];
          if (!_.isEmpty(response.data.Tickets)) {
            if (this.batchgroupPriceCategories.length === 0) {
              for (const [key, value] of Object.entries(response.data.Tickets)) {
                // this.potentialPriceCategories.push({ key, ...value });
                if (this.batchgroupForm.OrderType === 2 && value.Name === 'Free') {
                  value.Name = 'Deliveryfee';
                } else if (this.batchgroupForm.OrderType === 1 && value.Name === 'Deliveryfee') {
                  value.Name = 'Free';
                }
                this.potentialPriceCategories.push(value);
              }
            } else {
              for (const [key, value] of Object.entries(response.data.Tickets)) {
                let alreadyInside = false;
                for (const [elementKey, element] of this.batchgroupPriceCategories.entries()) {
                  console.log('element and value: ', element, value);
                  if (element.Id == value.Id) {
                    alreadyInside = true;
                    break;
                  }
                }
                console.log('alreadyInside: ', alreadyInside);
                if (!alreadyInside) {
                  this.potentialPriceCategories.push(value);
                }
              }
            }
          } else {
            console.log(' recieved data is empty');
          }
        },
        (error) => {
          console.log(
            'The generic call getPriceCategories was not successful',
            error,
          );
        },
        'getPriceCategories',
        appConfig.dss.eventAdminMng,
        payload,
      );
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    selectStartDate() {
      this.$refs.menu3.save(this.tmpStartDate);
      if (this.tmpEndDate == '') {
        this.tmpEndDate = this.tmpStartDate;
      }
    },
    selectEndDate() {
      this.$refs.menu4.save(this.tmpEndDate);
      this.tmpEndDate2 = this.tmpEndDate;
    },
    showDeleteBGDialog(item) {
      this.batchGroupToBeDelete = item;
      this.deleteBGDialog = true;
    },
    deleteBatchgroup() {
      const payload = BatchGroupObject._deleteRequestBatchgroup(
        this.batchGroupToBeDelete,
      );

      // Add PartnerId to the request
      if (Number(this.$store.getters['auth/partnerId']) <= 0) {
        payload.PartnerId = -1;
      } else {
        payload.PartnerId = Number(this.$store.getters['auth/partnerId']);
      }

      dssRequest.doRequest(
        (response) => {
          console.log('The call deleteBatchGroup was successful', response);
          this.deleteBGDialog = false;
          this.manageGetBatchGroup(this.eventConfig);
          window.EventBus.fire(
            'activateSnackBar',
            `There are ${response.data.FutureBookings} future bookings for the deleted batchgroup.`,
          );
        },
        (error) => {
          console.log('The call deleteBatchGroup was not succesfull', error);
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
          this.errorDeleteBatchGroup = true;
        },
        'deleteBatchGroup',
        appConfig.dss.eventAdminMng,
        payload,
      );
    },
    viewBGDetails(item) {

      if (item.Type === 'Repeating') this.radioSelect = 'repeat';
      else this.radioSelect = 'specific';
      if (item.hasOwnProperty('JoinedDays')) {
        this.daySelected = item.JoinedDays;
      }
      if (item.hasOwnProperty('JoinedDates')) {
        this.selectDates = [];
        item.JoinedDates.forEach((e) => {
          this.selectDates.push(e.split('-').reverse().join('-'));
        });
      }
      this.batchgroupPriceCategories = [];
      for (const [index, categorie] of Object.entries(item.PriceCategories)) {
        this.batchgroupPriceCategories.push(categorie);
      }
      if (item.hasOwnProperty('StartDate') && item.hasOwnProperty('EndDate')) {
        this.tmpStartDate = item.StartDate.split('-').reverse().join('-');
        this.tmpEndDate = item.EndDate.split('-').reverse().join('-');
      }

      this.getPolicies();
      this.editMode = true;
      this.batchConfig = item;
      this.openAddBg = true;
      this.potentialPriceCategories = [];
      for (const [key, value] of Object.entries(item.PriceCategories)) {
        this.potentialPriceCategories.push(value);
      }
    },
    signalCloseBatchGroupDialog(get) {
      // this.$refs.form.reset();
      window.EventBus.fire('closeBatchGroupDialog', get);
      this.radioSelect = null;
      this.daySelected = [];
      this.selectDates = [];
      this.openAddBg = false;
    },
    manageDataForComponent(data) {
      // this.getLocations(data);
      this.eventForm = data;
      this.eventConfig = data;
      if (!_.isEmpty(data)) {
        this.disableFields(true);
        if (this.eventConfig.memberOf !== undefined) {
          this.eventConfig.memberOf.forEach((e) => {
            if (
              e.grantType === 'OWNER'
                && e.accountId == this.currentAccountId
            ) {
              this.disableFields(false);
            }
          });
        }
      } else {
        this.disableFields(true);
      }

      if (!_.isEmpty(data)) {
        this.manageGetBatchGroup(data);
        this.userGroupsSelected = [];
        if (
          this.eventForm.memberOf !== undefined
            && this.eventForm.memberOf.length > 0
        ) {
          this.eventForm.memberOf.forEach((e) => {
            if (e.grantType === 'VISIBLE') {
              this.userGroupsSelected.push(e);
            }
          });
        }
        if (this.eventForm.memberOf !== undefined) {
          const copy = this.eventForm.tags;
          this.eventForm.tags = [];
          for (const [k, v] of Object.entries(copy)) {
            if (v.Selected == 'yes') {
              const id = v.TagId;
              this.eventForm.tags.push(v);
            }
          }
        }
      } else {
        this.eventForm = CreateEventObject2._objectDefinition();
      }
    },
    disableFields(status) {
      this.disableAdd = status;
    },
    manageGetBatchGroup(detail) {
      const payload = {
        EventId: detail.eventId,
        FunctionId: 'EventFunctionLibrary::getBatchGroups',
      };

      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call getBatchGroups was successful',
            response,
          );
          delete response.data.ErrorMsg;
          this.batchGroupList = this.makePrettyOutput(response.data);
          this.filteredBatchGroupList = objectToArray(this.batchGroupList);
        },
        (error) => {
          console.log(
            'The generic call getBatchGroups was not successful',
            error,
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        'communicateWithDBLibrary',
        appConfig.dss.eventAdminMng,
        payload,
      );
    },

    makePrettyOutput(data) {
      for (const [key, value] of Object.entries(data)) {

        value.BatchGroupId = key;
        if (value.hasOwnProperty('Dates')) {
          value.JoinedDates = (Object.values(value.Dates));
        }
        if (value.hasOwnProperty('StartDate')) {
          value.JoinedDays = (Object.values(value.Days));
        }
        if (value.hasOwnProperty('PricePercentage')) {
          value.PricePercentage *= 100;
        }
        if (value.hasOwnProperty('BatchFrequency')) {
          value.BatchFrequency /= 60;
        }
        if (value.hasOwnProperty('ArrivalBatchDuration')) {
          value.ArrivalBatchDuration /= 60;
        }
        if (value.hasOwnProperty('DepartureBatchDuration')) {
          value.DepartureBatchDuration /= 60;
        }

        if (Object.keys(value.PriceCategories).length > 0) {
          for (const [key, item] of Object.entries(value.PriceCategories)) {
            this.batchgroupPriceCategories.push({
              PriceCategoryId: item.PriceCategoryId,
              Name: item.Name,
              Price: item.Price,
              Description: item.Description,
            });
          }
        }
      }
      return data;
    },
    addBatchgroup() {
      const freshInput = {
        eventId: this.eventConfig.eventId,
        locationId: this.eventConfig.locationId,
        type: this.eventConfig.type,
      };
      this.batchgroupPriceCategories = [];
      this.editMode = false;
      this.eventConfig = freshInput;
      this.batchConfig = {};

      this.openAddBg = true;

      this.getPolicies();
    },
    setRadio() {
      if (this.radioSelect == 'repeat') {
        this.daySelected = [];
        this.tmpStartDate = '';
        this.tmpEndDate = '';
        this.tmpEndDate2 = '';
      } else if (this.radioSelect == 'specific') {
        this.selectDates = [];
      }
    },

    closeBatchGroupDialog(params) {
      this.editMode = false;
      this.openAddBg = false;
      if (params.reload == true) {
        this.manageGetBatchGroup(this.eventConfig);
      }
    },
    savingBatchgroup() {
      if (
        this.$refs.batchgroupForm.validate()
          && this.selectDates.length !== 0
      ) {
        this.snackbar = true;
      } else if (
        this.$refs.batchgroupForm.validate()
          && this.daySelected.length !== 0
      ) {
        this.snackbar = true;
      } else {
        this.errorDialog = true;
        return;
      }
      let now = new Date();
      let then = new Date();
      if (this.picker !== null) {
        const date = new Date(this.picker);
        const year = date.getUTCFullYear();
        const month = date.getUTCMonth();
        const day = date.getUTCDate();
        const startHour = Date.UTC(year, month, day, 0, 0, 0, 0) / 1000;
        const endHour = startHour + 86400;

        now = new Date(startHour * 1000);
        then = new Date(endHour * 1000);
      } else {
        now.setHours(0);
        then.setMonth(then.getMonth() + 1);
      }
      this.batchgroupForm.Container = this.partOfSelection;
      // if repetitive or tour the arrival batch duration is equal to the departure batch duration
      if (this.eventConfig.Type === 'Repetitive' || this.eventConfig.Type === 'Tour') {
        this.batchgroupForm.ArrivalBatchDuration = this.batchgroupForm.DepartureBatchDuration;
      }
      // if repetitive or tour than maxInFlow is equal to maxOutFlow
      if (this.eventConfig.Type === 'Repetitive' || this.eventConfig.Type === 'Tour') {
        this.batchgroupForm.MaxInflow = this.batchgroupForm.MaxOutflow;
      }
      // check if eventType == Rental and then check if the minArrivalTime input is correct and/or add the : to the time
      if (this.eventConfig.type === 'Rental' ||
          this.eventConfig.type === 'FlexEvent' ||
          this.eventConfig.type === 'Fixed' ||
          this.eventConfig.type === 'Repetitive' ||
          this.eventConfig.type === 'Tour' ||
          this.eventConfig.type === 'OrderEvent' ||
          this.eventConfig.type === 'Delivery' ||
          this.eventConfig.type === 'PickUp'
      ) {
        if (
          this.batchgroupForm.MinArrivalTime.length !== 4
            || this.batchgroupForm.MinArrivalTime.charAt(0) > '2'
            || (this.batchgroupForm.MinArrivalTime.charAt(0) === '2'
              && this.batchgroupForm.MinArrivalTime.charAt(1) >= '4')
            || this.batchgroupForm.MinArrivalTime
            >= this.batchgroupForm.MaxArrivalTime
        ) {
          if (this.batchgroupForm.MinArrivalTime.length === 5 && this.batchgroupForm.MinArrivalTime.charAt(2) === ':') {
          } else {

            window.EventBus.fire('inputDialog');
            return null;
          }
        }
        if (
          this.batchgroupForm.MinArrivalTime.charAt(2) === '6'
            || this.batchgroupForm.MinArrivalTime.charAt(2) === '7'
            || this.batchgroupForm.MinArrivalTime.charAt(2) === '8'
            || this.batchgroupForm.MinArrivalTime.charAt(2) === '9'
            || this.batchgroupForm.MinArrivalTime.length > 5
        ) {
          window.EventBus.fire('inputDialog');
          return null;
        }

        if (this.batchgroupForm.MinArrivalTime.charAt(2) !== ':') {
          this.batchgroupForm.MinArrivalTime = `${this.batchgroupForm.MinArrivalTime.slice(0, 2)
          }:${
            this.batchgroupForm.MinArrivalTime.slice(2, 4)}`;
        }
      }

      // check if eventType == Rental and then check if the maxArrivalTime input is correct and/or add the : to the time
      if (this.eventConfig.type == 'Rental' ||
          this.eventConfig.type === 'FlexEvent' ||
          this.eventConfig.type === 'Fixed' ||
          this.eventConfig.type === 'Repetitive' ||
          this.eventConfig.type === 'Tour' ||
          this.eventConfig.type === 'OrderEvent' ||
          this.eventConfig.type === 'Delivery' ||
          this.eventConfig.type === 'PickUp'
      ) {
        if (
          this.batchgroupForm.MaxArrivalTime.length !== 4
            || this.batchgroupForm.MaxArrivalTime.charAt(0) > '2'
            || (this.batchgroupForm.MaxArrivalTime.charAt(0) === '2'
              && this.batchgroupForm.MaxArrivalTime.charAt(1) >= '4')
        ) {
          if (this.batchgroupForm.MinArrivalTime.length === 5 && this.batchgroupForm.MinArrivalTime.charAt(2) === ':') {
          } else {
            window.EventBus.fire('inputDialog');
            return null;
          }
        }
        if (
          this.batchgroupForm.MaxArrivalTime.charAt(2) === '6'
            || this.batchgroupForm.MaxArrivalTime.charAt(2) === '7'
            || this.batchgroupForm.MaxArrivalTime.charAt(2) === '8'
            || this.batchgroupForm.MaxArrivalTime.charAt(2) === '9'
            || this.batchgroupForm.MaxArrivalTime.length > 5
        ) {
          window.EventBus.fire('inputDialog');
          return null;
        }

        if (this.batchgroupForm.MaxArrivalTime.charAt(2) !== ':') {
          this.batchgroupForm.MaxArrivalTime = `${this.batchgroupForm.MaxArrivalTime.slice(0, 2)
          }:${
            this.batchgroupForm.MaxArrivalTime.slice(2, 4)}`;
        }
      }

      // check if eventType == Rental and then check if the minDepartureTime input is correct and/or add the : to the time
      if (this.eventConfig.type === 'Rental' ||
          this.eventConfig.type === 'FlexEvent' ||
          this.eventConfig.type === 'Fixed'
      ) {
        if (
          this.batchgroupForm.MinDepartureTime.length != 4
            || this.batchgroupForm.MinDepartureTime.charAt(0) > '2'
            || (this.batchgroupForm.MinDepartureTime.charAt(0) == '2'
              && this.batchgroupForm.MinDepartureTime.charAt(1) >= '4')
            || this.batchgroupForm.MinDepartureTime
            >= this.batchgroupForm.MaxDepartureTime
        ) {
          if (this.batchgroupForm.MinArrivalTime.length === 5 && this.batchgroupForm.MinArrivalTime.charAt(2) === ':') {
          } else {
            window.EventBus.fire('inputDialog');
            return null;
          }
        }
        if (
          this.batchgroupForm.MinDepartureTime.charAt(2) == '6'
            || this.batchgroupForm.MinDepartureTime.charAt(2) == '7'
            || this.batchgroupForm.MinDepartureTime.charAt(2) == '8'
            || this.batchgroupForm.MinDepartureTime.charAt(2) == '9'
            || this.batchgroupForm.MinDepartureTime.length > 5
        ) {
          window.EventBus.fire('inputDialog');
          return null;
        }

        if (this.batchgroupForm.MinDepartureTime.charAt(2) !== ':') {
          this.batchgroupForm.MinDepartureTime = `${this.batchgroupForm.MinDepartureTime.slice(0, 2)
          }:${
            this.batchgroupForm.MinDepartureTime.slice(2, 4)}`;
        }
      }

      // check if eventType == Rental and then check if the maxDepartureTime input is correct and/or add the : to the time
      if (this.eventConfig.type === 'Rental' ||
          this.eventConfig.type === 'FlexEvent' ||
          this.eventConfig.type === 'Fixed'
      ) {
        if (
          this.batchgroupForm.MaxDepartureTime.length != 4
            || this.batchgroupForm.MaxDepartureTime.charAt(0) > '2'
            || (this.batchgroupForm.MaxDepartureTime.charAt(0) == '2'
              && this.batchgroupForm.MaxDepartureTime.charAt(1) >= '4')
        ) {
          if (this.batchgroupForm.MinArrivalTime.length === 5 && this.batchgroupForm.MinArrivalTime.charAt(2) === ':') {
          } else {
            window.EventBus.fire('inputDialog');
            return null;
          }
        }
        if (
          this.batchgroupForm.MaxDepartureTime.charAt(2) == '6'
            || this.batchgroupForm.MaxDepartureTime.charAt(2) == '7'
            || this.batchgroupForm.MaxDepartureTime.charAt(2) == '8'
            || this.batchgroupForm.MaxDepartureTime.charAt(2) == '9'
            || this.batchgroupForm.MaxDepartureTime.length > 5
        ) {
          window.EventBus.fire('inputDialog');
          return null;
        }

        if (this.batchgroupForm.MaxDepartureTime.charAt(2) !== ':') {
          this.batchgroupForm.MaxDepartureTime = `${this.batchgroupForm.MaxDepartureTime.slice(0, 2)
          }:${
            this.batchgroupForm.MaxDepartureTime.slice(2, 4)}`;
        }
      }

      let payload = {};

      if (this.radioSelect == 'repeat') {
        if (this.tmpStartDate == this.tmpEndDate) {
          this.wrongDateDialog = true;
          return null;
        }
      }
      this.batchgroupForm.EndDate = new Date(this.tmpEndDate)
        .toLocaleDateString('nl-NL')
        .split('/')
        .join('-');
      this.batchgroupForm.StartDate = new Date(this.tmpStartDate)
        .toLocaleDateString('nl-NL')
        .split('/')
        .join('-');
      this.batchgroupForm.BookingPolicy = this.batchgroupForm.BookingPolicy.BookingPolicyId;
      if (this.batchgroupForm.BookingPolicy === NaN) {
        this.batchgroupForm.BookingPolicy = 0;
      }
      if (this.eventForm.type !== 'OrderEvent') {
        this.batchgroupForm.Duration = 0;
        this.batchgroupForm.Type = 0;
      }

      const toStorePriceCategories = {};
      if (this.batchgroupPriceCategories.length > 0) {
        this.batchgroupPriceCategories.forEach((e) => {
          toStorePriceCategories[Number(e.PriceCategoryId)] = {
            Price: Number(e.Price).toFixed(2),
            FreeThreshold: e.FreeThreshold !== '' ? e.FreeThreshold : -1,
          };
        });
        this.batchgroupForm.PriceCategories = toStorePriceCategories;
      } else {
        if(this.eventConfig.type !== "Delivery" && this.eventConfig.type !== "PickUp") {
          this.errorPriceCategoriesDialog = true;
          return;
        }
      }
      if (this.radioSelect === 'repeat') {
        payload = BatchGroupObject._createEventRepeatRequestObject(
          this.batchgroupForm,
          this.daySelected,
          this.eventConfig,
        );
      } else if (this.radioSelect === 'specific') {
        payload = BatchGroupObject._createEventSpecificRequestObject(
          this.batchgroupForm,
          this.selectDates,
          this.eventConfig,
        );
      }

      this.partOfDialog = false;
      // Add PartnerId to the request
      if (Number(this.$store.getters['auth/partnerId']) <= 0) {
        payload.PartnerId = -1;
      } else {
        payload.PartnerId = Number(this.$store.getters['auth/partnerId']);
      }

      // Check if editMode is true, if true than add the BatchGroup-ID to the payload
      if (this.editMode) payload.BatchGroupId = Number(this.batchgroupForm.BatchGroupId);

      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call for saveBatchGroup was successful',
            response,
          );
          const get = { reload: true };
          this.signalCloseBatchGroupDialog(get);
          this.manageGetBatchGroup(this.eventConfig);
        },
        (error) => {
          console.log(
            'The generic call for saveBatchGroup was not successful',
            error,
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        'saveBatchGroup',
        this.eventConfig.eventId,
        payload,
      );
    },
    allowedDatesFromSelectDates(val) {
      if (this.batchConfig.JoinedDates !== undefined) {
        if (!this.batchConfig.JoinedDates.includes(val.split('-').reverse().join('-'))) return val;
      } else {
        return val;
      }
    },
    getTodayDate() {
      const year = new Date().getFullYear();
      let month = `${new Date().getMonth() + 1}`;
      let day = `${new Date().getDate()}`;
      console.log('Lorenzo month.length', month.length);
      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;
      this.today = `${year}-${month}-${day}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  .scrollableBatchgroupList {
    height: 30em;
    margin-bottom: 2em;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .dialogAddBG {
    padding: 2em;
    max-width: 100%;
    overflow-y: hidden;
  }

  .lindaLogo {
    width: 17em;
    height: 30em;
  }

  .lindaTextMediumBatchgroup {
    max-height: 22em !important;
    margin-left: -2.5em !important;
    margin: 15px;
    border-radius: 1em !important;
    max-width: 21em !important;
  }

  .checkbox_lining {
    margin-left: -6em;
  }

  .selectedDays {
    margin-left: -0.5em;
  }
  .priceCategoriesCard {
    margin-right: -1.5em;
    margin-left: -0.3em;
  }
  .blockForInputfields {
    padding: 1em;
  }
</style>
